import { OktaAuth } from "@okta/okta-auth-js";
import { Application } from "../config/const/enums";

var oktaAuthConfig = {
	issuer: "",
	clientId: "",
	redirectUri: "http://localhost:8080/login/callback",
	pkce: true,
	tokenManager: {
		autoRenew: false,
	},
};

let oktaAuthClient = null;
const oktaIssuer = import.meta.env.VITE_OKTA_CLIENT_ISSUER;
const oktaClientId = import.meta.env.VITE_OKTA_CLIENT_ID;

const initOktaConfig = (applicationType) => {
	oktaAuthConfig.issuer = oktaIssuer;
	oktaAuthConfig.clientId = oktaClientId;
	if (applicationType === Application.ONLINE) {
		// online application
		oktaAuthConfig.scopes = ["openid"];
	} else {
		oktaAuthConfig.scopes = ["openid", "tl_call_centre"];
	}
	oktaAuthClient = new OktaAuth(oktaAuthConfig);
	oktaAuthClient.start();
};
const clearStorage = (applicationType) => {
	initOktaConfig(applicationType);
	if (oktaAuthClient) {
		oktaAuthClient.closeSession();
	}
	sessionStorage.clear();
	localStorage.removeItem("okta-cache-storage");
	localStorage.removeItem("okta-pkce-storage");
	localStorage.removeItem("okta-token-storage");
	localStorage.removeItem("okta-shared-transaction-storage");
};

const getOktaAuthClient = () => {
	// if oktaCLient doesnt exist then create a new one -->needs to be done
	return oktaAuthClient;
};

export default {
	initOktaConfig: initOktaConfig,
	getOktaAuthClient: getOktaAuthClient,
	clearStorage: clearStorage,
};
